import React, { FC, Fragment, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import SubscribeForm from 'components/SubscribeForm'
import IconInstagram from 'components/Icons/Instagram'
import IconFacebook from 'components/Icons/Facebook'

import IconPin from 'components/Icons/Pin'
import IconEmail from 'components/Icons/Email'
import { IconTelegram } from 'components/Icons/Telegram'
import IconYoutube from 'components/Icons/Youtube'

import { useStore } from 'helpers/useStore'

import styles from './index.module.scss'
import classNames from 'classnames/bind'
import { socials } from 'constants/config'

const cx = classNames.bind(styles)

interface FooterProps {
	hideContacts?: boolean
	isShort?: boolean
	classNames?: any
	isWhite?: boolean
}

const Footer: FC<FooterProps> = ({ hideContacts, isShort, classNames, isWhite }) => {
	const [t] = useTranslation()
	const pathname = useStore((state) => state.router.location.pathname)
	const year = useMemo(() => new Date().getFullYear(), [])
	return (
		<footer
			className={cx('Component', {
				Component_white_bg: pathname === '/search' || pathname === '/dashboard' || isWhite
			})}
		>
			{!isShort && (
				<div className={cx('Main')}>
					<div className={cx('Container', classNames || '')}>
						<nav className={cx('Nav')}>
							{/*<h4>*/}
							{/*	<Link to="/organizers">{t('footer.resources')}</Link>*/}
							{/*</h4>*/}
							<Link to="/terms">{t('footer.terms')}</Link>
							<Link to="/privacy">{t('footer.policy')}</Link>
							{/* <Link to="/support">{t('footer.support')}</Link>
							<Link to="/contact">{t('footer.contactInformation')}</Link> */}
							<Link to="/faq">{t('footer.faq')}</Link>
						</nav>
						<div className={cx('Contacts')}>
							<h4> {t('footer.office.title')}</h4>
							<address>
								<IconPin className={cx('IconPin')} />
								РГ "КЄМГ" <br /> 01001, м. Київ, <br /> вул. Лютеранська, 4, кв. 27
								{/* {t('footer.office.full_address')} */}
								{/* {t('footer.office.city')} */}
							</address>
							{!hideContacts && (
								<Fragment>
									{/*<a href="tel:+380509421693"><IconPhone/> +380509421693</a>*/}
									<a href={`mailto:${socials.email}`}>
										<IconEmail /> {socials.email}
									</a>
								</Fragment>
							)}
							<a href={socials.telegram} target={'_blank'}>
								{' '}
								{t('footer.telegram')}
							</a>
						</div>
						<div className={cx('Subscribe')}>
							<SubscribeForm />
							<div className={cx('Socials')}>
								<a href={socials.instagram} target={'_blank'}>
									<IconInstagram />
								</a>
								<a href={socials.facebook} target={'_blank'}>
									<IconFacebook />
								</a>
								<a href={socials.telegram} target={'_blank'}>
									<IconTelegram />
								</a>
								<a href={socials.youtube} target={'_blank'}>
									<IconYoutube />
								</a>
							</div>
						</div>
					</div>
				</div>
			)}
			<div className={cx('Additional', classNames)}>
				<div className={cx('PaymentSystems')}>
					<div>
						<img
							// width="450"
							// height="24px"
							src={require('assets/img/paymentSystems/logo-gor-black.png')}
							alt=""
						/>
					</div>
					{/* <div>
						<img width="86" height="20" src={require('assets/img/paymentSystems/visa_logo.png')} alt="" />
					</div> */}
					{/* <div>
						<img src={require('assets/img/paymentSystems/fondy_logo.svg')} alt="" />
					</div> */}
				</div>

				<a href="https://barva.tech/" className={cx('MadeByLogo')}>
					{/* <img src={require('assets/img/logo-barvatech.svg')} alt="" /> */}

					<span className={cx('MadeByText')}>made by</span>

					<svg width="80" height="14" viewBox="0 0 80 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_10668_42028)">
							<path
								d="M8.58232 5.7C8.20978 5.28526 7.76138 4.95205 7.26341 4.71989C6.76543 4.48773 6.2279 4.3613 5.68232 4.348C4.76309 4.30611 3.86496 4.64237 3.18232 5.284V3.516H1.43232C1.8396 3.34713 2.21274 3.10018 2.53232 2.788C3.33232 1.956 3.18232 0.5 3.18232 0.5H0.882324V13.188H2.88232L3.18232 12.408C3.43232 12.72 3.78232 12.928 4.28232 13.136C5.01811 13.4206 5.81815 13.4738 6.58278 13.2888C7.3474 13.1039 8.0428 12.6891 8.58232 12.096C9.33662 11.2067 9.74645 10.0578 9.73232 8.872C9.74645 7.68624 9.33662 6.53729 8.58232 5.648V5.7ZM7.38232 9.86L6.88232 10.588C6.68232 10.796 6.48232 11.004 6.18232 11.108C5.91718 11.2416 5.62693 11.3126 5.33232 11.316C5.04244 11.3156 4.75482 11.2629 4.48232 11.16C4.23174 11.0608 4.00417 10.9076 3.81459 10.7104C3.625 10.5133 3.47768 10.2766 3.38232 10.016C3.28232 9.704 3.23232 9.34 3.23232 8.976C3.23232 8.456 3.28232 8.092 3.38232 7.78C3.53232 7.468 3.68232 7.26 3.88232 7.052C4.08232 6.844 4.28232 6.74 4.53232 6.636C4.83232 6.532 5.08232 6.532 5.38232 6.532C5.6732 6.51904 5.96329 6.57228 6.23232 6.688C6.53232 6.844 6.73232 7 6.93232 7.208C7.13232 7.416 7.28232 7.676 7.43232 7.988C7.66072 8.5894 7.66072 9.2586 7.43232 9.86H7.38232ZM17.0823 5.44C16.7902 5.08138 16.41 4.81182 15.9823 4.66C14.9606 4.28889 13.8398 4.34758 12.8591 4.82357C11.8783 5.29956 11.1152 6.15519 10.7323 7.208C10.5323 7.728 10.4323 8.352 10.4323 8.976C10.4305 10.1439 10.8396 11.2721 11.5823 12.148C12.124 12.7544 12.8255 13.1813 13.5991 13.3756C14.3728 13.5698 15.1843 13.5226 15.9323 13.24C16.4323 13.084 16.7823 12.824 17.0823 12.356L17.3323 13.292H19.3323V4.608H17.3323L17.0823 5.44ZM16.3823 10.692C16.1203 10.947 15.8023 11.1314 15.456 11.2293C15.1097 11.3271 14.7456 11.3354 14.3955 11.2533C14.0455 11.1713 13.72 11.0014 13.4475 10.7586C13.1751 10.5157 12.9639 10.2072 12.8323 9.86C12.6621 9.41468 12.6187 8.92781 12.7074 8.45754C12.796 7.98726 13.013 7.55348 13.3323 7.208C13.4823 7 13.7323 6.844 13.9823 6.688C14.2475 6.5544 14.5377 6.48338 14.8323 6.48C15.1323 6.48 15.4323 6.532 15.6823 6.636C15.9547 6.71523 16.2053 6.8601 16.4138 7.05886C16.6223 7.25762 16.7828 7.50467 16.8823 7.78C17.0323 8.092 17.0823 8.456 17.0823 8.924C17.0823 9.756 16.8323 10.328 16.4323 10.692H16.3823ZM40.7823 4.66L40.5823 5.544C40.2766 5.13088 39.8585 4.82289 39.3823 4.66C38.3669 4.28605 37.2514 4.33739 36.2717 4.80317C35.292 5.26896 34.5248 6.11268 34.1323 7.156C33.9323 7.676 33.8323 8.3 33.8323 8.924C33.8305 10.0919 34.2396 11.2201 34.9823 12.096C35.5183 12.7113 36.2171 13.1482 36.9911 13.3518C37.765 13.5553 38.5796 13.5164 39.3323 13.24C39.8323 13.084 40.1823 12.772 40.5323 12.304L40.7323 13.24H42.7323V4.608H40.7323L40.7823 4.66ZM39.8823 10.744C39.6169 10.9865 39.2992 11.1589 38.9561 11.2467C38.613 11.3344 38.2547 11.335 37.9114 11.2483C37.568 11.1616 37.2498 10.9901 36.9837 10.7485C36.7175 10.5068 36.5113 10.2021 36.3823 9.86C36.2323 9.548 36.1823 9.236 36.1823 8.924C36.1752 8.28567 36.4085 7.66976 36.8323 7.208L37.4823 6.688C37.7514 6.57228 38.0415 6.51904 38.3323 6.532C38.6323 6.532 38.9323 6.532 39.1823 6.636C39.4508 6.7275 39.6948 6.88345 39.8946 7.09122C40.0944 7.299 40.2443 7.55277 40.3323 7.832C40.4823 8.144 40.5323 8.508 40.5323 8.976C40.5323 9.756 40.2823 10.328 39.8823 10.744ZM32.2323 4.504L29.8323 10.9L27.4823 4.556H26.5323C25.6823 4.4 23.7323 4.296 23.0323 5.492C22.8823 5.7 22.4823 6.792 22.3323 6.948V4.66H20.0323V13.292H22.3823V8.716C22.3823 8.404 22.4823 8.144 22.5823 7.884C22.7323 7.624 22.9323 7.364 23.1323 7.208C23.3689 7.00199 23.6402 6.84332 23.9323 6.74C24.4689 6.57527 25.0372 6.55736 25.5823 6.688H25.8823L28.3823 13.188H31.3823L34.7323 4.608H32.2323V4.504ZM49.1323 4.556H45.0323L45.8823 6.74H49.0823V10.64C49.0823 11.16 49.1323 11.68 49.2823 12.044C49.4823 12.408 49.6823 12.72 49.9323 12.928C50.1823 13.136 50.4323 13.344 50.7823 13.448L51.7823 13.552C52.1323 13.552 52.4323 13.552 52.7823 13.448L53.6323 13.24V11.212C53.3318 11.3452 53.009 11.4159 52.6823 11.42C52.2823 11.42 51.9823 11.316 51.7323 11.108C51.5323 10.848 51.3823 10.588 51.3823 10.12V6.74H53.6323V4.66H49.1323V4.556ZM61.3823 5.804C61.0007 5.37037 60.5424 5.01727 60.0323 4.764C59.5323 4.504 58.9823 4.4 58.3323 4.4C57.7469 4.39047 57.1665 4.51473 56.6323 4.764C55.6057 5.2352 54.7854 6.08831 54.3323 7.156C53.9828 7.9936 53.8913 8.92321 54.0704 9.81709C54.2494 10.711 54.6903 11.5252 55.3323 12.148C56.2463 13.0139 57.4463 13.4795 58.6823 13.448C59.258 13.4466 59.8306 13.359 60.3823 13.188C60.9323 13.032 61.3823 12.824 61.8323 12.512L61.0323 11.056C60.2935 11.3276 59.516 11.4682 58.7323 11.472C58.2679 11.4508 57.8156 11.3118 57.4147 11.0671C57.0138 10.8223 56.6765 10.4794 56.4323 10.068H62.4323C62.638 9.13233 62.5683 8.15394 62.2323 7.26C62.0323 6.74 61.7323 6.22 61.3823 5.804ZM56.3823 8.196C56.5323 7.676 56.7823 7.312 57.1323 7C57.4823 6.688 57.8823 6.48 58.3323 6.48C58.7823 6.48 59.1823 6.688 59.5323 7C59.8323 7.312 60.0823 7.728 60.2323 8.196H56.3823ZM65.7823 7.26C65.9823 7.052 66.1823 6.844 66.4323 6.74C66.6823 6.584 66.9323 6.532 67.2323 6.532C67.5323 6.532 67.8323 6.584 68.0823 6.688C68.3823 6.844 68.6823 7.052 68.9823 7.364L70.5823 6.064C70.0273 5.31753 69.2595 4.77277 68.3887 4.50766C67.518 4.24256 66.5889 4.27071 65.7344 4.58808C64.88 4.90545 64.1439 5.49577 63.6316 6.27458C63.1194 7.05339 62.8571 7.98076 62.8823 8.924C62.9017 9.80678 63.1608 10.6658 63.6297 11.402C64.0986 12.1381 64.7582 12.7212 65.5323 13.084C66.0323 13.344 66.6323 13.448 67.2323 13.448C67.8823 13.448 68.4823 13.292 69.0823 13.032C69.6245 12.7399 70.1015 12.3324 70.4823 11.836L69.0823 10.38C68.8602 10.6731 68.58 10.9131 68.2608 11.0836C67.9416 11.254 67.5908 11.3511 67.2323 11.368C66.9323 11.368 66.6823 11.316 66.4323 11.16C66.1893 11.0438 65.9712 10.8781 65.7908 10.6726C65.6105 10.4672 65.4715 10.2262 65.3823 9.964C65.2286 9.5109 65.1893 9.02436 65.2681 8.55094C65.3469 8.07751 65.5411 7.63302 65.8323 7.26H65.7823ZM79.5823 7.104C79.3823 6.584 79.0823 6.064 78.7823 5.648C78.4353 5.23287 78.0098 4.89654 77.5323 4.66C77.0645 4.42433 76.5521 4.29999 76.0323 4.296C75.5323 4.296 75.0823 4.4 74.7323 4.556C74.3823 4.712 74.0323 4.92 73.7323 5.232V0.5H71.3823V13.188H73.7323V8.768C73.7323 8.404 73.7323 8.04 73.8823 7.728L74.2823 7.052C74.4823 6.844 74.6823 6.688 74.9323 6.584C75.1703 6.48231 75.425 6.42934 75.6823 6.428C75.9323 6.428 76.1823 6.532 76.4323 6.688C76.6823 6.792 76.9323 7 77.0823 7.208L77.4823 8.04L77.6323 9.028V13.136H79.8823V8.872C79.8823 8.196 79.7823 7.624 79.5823 7.104ZM46.7823 10.692H44.3823V13.24H46.8823V10.692H46.7823ZM51.4323 1.436H49.1323V4.556C49.1323 4.556 49.8823 4.452 50.7823 3.62C51.5823 2.84 51.4323 1.384 51.4323 1.384V1.436Z"
								fill="#0A051C"
							/>
						</g>
						<defs>
							<clipPath id="clip0_10668_42028">
								<rect width="79" height="13" fill="white" transform="translate(0.882324 0.5)" />
							</clipPath>
						</defs>
					</svg>
				</a>

				<p>© KJMC.Kyiv, {year}</p>
			</div>
		</footer>
	)
}

export default Footer
